/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'approversUserGroupPosition';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'globalUserGroupApproverByPosition';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'approverUserGroupPosition';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'approversUserGroupPosition';

/** Default list sort — matches legacy `useManageUserGroupApproverPosition`. */
export const DEFAULT_ORDER_BY = 'userGroup/name asc';
